import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { TradecreditorsSoletraderService } from './service/tradecreditors-soletrader.service';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-tradecreditors-soletrader',
  templateUrl: './tradecreditors-soletrader.component.html',
  styleUrls: ['./tradecreditors-soletrader.component.scss']
})
export class TradecreditorsSoletraderComponent implements OnInit {


  Amount: number;
  Amount_LY: number;
  isJump: any;
  CreateTradecreditorsSoletraderFormGroup: FormGroup;
  NormalRoutng: boolean;
  disableSoleTrader: boolean;
  valid: boolean = true;
  constructor(public FormBuilder: FormBuilder, public TradecreditorsSoletraderService: TradecreditorsSoletraderService, public Router: Router, public commonService: CommonService) {

  }


  ngOnInit(): void {
    debugger
    this.commonService.getIncomeStatementsHeaders();
    this.isJump = localStorage.getItem('isJump');
    this.CreateTradecreditorsSoletraderForm();
    this.ListCreateTradecreditorsSoletraderFormGroupGrid.clear();
    this.GetTradecreditorsSoletrader();
    this.commonService.getNotesData();
    this.clearfield();

    if (localStorage.getItem("SubmitStatus") == "true") {
      this.CreateTradecreditorsSoletraderFormGroup.disable();
      this.disableSoleTrader = true;
    }
  }

  CreateTradecreditorsSoletraderForm() {
    this.CreateTradecreditorsSoletraderFormGroup = this.FormBuilder.group({
      TradeCreditorsSoleTraderId: new FormControl(),
      Total: new FormControl({ value: '', disabled: true }),
      Total_LY: new FormControl({ value: '', disabled: true }),
      AdditionalInformation: new FormControl(),
      CreatedBy: new FormControl(localStorage.getItem('LoginuserId')),
      CreatedDate: new FormControl(),
      ModifiedBy: new FormControl(),
      ModifiedDate: new FormControl(),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),

      MatchingData: new FormControl(),

      Wizardrows: this.FormBuilder.array([
        this.FormBuilder.group({
          DetailsId: new FormControl(),
          TradeCreditorsSoleTraderId: new FormControl(),
          ItemDescription: new FormControl(),
          Amount: new FormControl(),
          Amount_LY: new FormControl(),
          CreatedDate: new FormControl(),
          ModifiedBy: new FormControl(),
          ModifiedDate: new FormControl(),
        })])
    });
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        var MatchingData = this.CreateTradecreditorsSoletraderFormGroup.controls['MatchingData'].value;
        this.CreateTradecreditorsSoletraderFormGroup.reset();
        this.CreateTradecreditorsSoletraderFormGroup.controls['MatchingData'].setValue({ Item1: MatchingData.Item1, Item2: MatchingData.Item2 });
        this.CreateTradecreditorsSoletraderFormGroup.controls['APPeriodId'].setValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
        this.ListCreateTradecreditorsSoletraderFormGroupGrid.clear();
      }
    })
  }

  GetTradecreditorsSoletrader() {
    debugger;
    this.TradecreditorsSoletraderService.GetOneTradecreditorsSoletrader(this.CreateTradecreditorsSoletraderFormGroup.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger;
      if (data.Wizardrows)
        for (let i = 0; i < data.Wizardrows.length; i++) {
          this.ListCreateTradecreditorsSoletraderFormGroupGrid.push(this.FormBuilder.group({
            TradecreditorsSoletraderId: data.Wizardrows[i].TradecreditorsSoletraderId,
            ItemDescription: data.Wizardrows[i].ItemDescription, Amount: data.Wizardrows[i].Amount, Amount_LY: data.Wizardrows[i].Amount_LY
          }));
        }
      this.CreateTradecreditorsSoletraderFormGroup.patchValue(data);
      this.CreateTradecreditorsSoletraderFormGroup.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));

    })
  }

  On_Next() {
    debugger;
    if (this.Gridvalidations() && this.On_NextBalancesheatValidaton()) {
      this.TradecreditorsSoletraderService.SaveTradecreditorsSoletrader(this.CreateTradecreditorsSoletraderFormGroup.getRawValue()).subscribe(data => {
        this.CreateTradecreditorsSoletraderFormGroup.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Trade Creditors", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.Router.navigate(['/notes'])
        else if (nextPage == 'tradecreditors') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.Router.navigate([nextPage]);
        }
        else {
          this.Router.navigate([nextPage]);
        }
      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  On_Back() {
    debugger;
    this.CreateTradecreditorsSoletraderFormGroup.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.Router.navigate(['/notes'])
    else if (backpage == 'tradecreditors') {
      this.Router.navigate(['/notes']);
    }
    else {
      backpage = this.commonService.getBackSelection("Trade Creditors", this.commonService.NotesList)
      this.Router.navigate([backpage]);
    }
  }

  AddNew() {
    debugger;
    if (this.Gridvalidations()) {
      this.valid = true;
      this.ListCreateTradecreditorsSoletraderFormGroupGrid.push(this.FormBuilder.group({ TradeCreditorsSoleTraderId: '', ItemDescription: '', Amount: '', Amount_LY: '' }));
    }

  }

  DeleteRow(index) {
    debugger;
    Swal.fire({
      titleText: "Andica Accounts Production",
      text: 'Are you sure you want to delete?',
      icon: "question",
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((data) => {
      if (data.value) {
        this.ListCreateTradecreditorsSoletraderFormGroupGrid.removeAt(index);
        this.CalculationsGrid();
      }
    })
  }

  Gridvalidations() {
    debugger;
    if (this.ListCreateTradecreditorsSoletraderFormGroupGrid.length) {
      var data = [];
      for (var j = 0; j < this.ListCreateTradecreditorsSoletraderFormGroupGrid.length; j++) {
        var v = this.CreateTradecreditorsSoletraderFormGroup.value.Wizardrows.filter(x => x.ItemDescription == this.ListCreateTradecreditorsSoletraderFormGroupGrid.value[j].ItemDescription)
        if (v.length > 1) {
          data = v;
          Swal.fire("Andica Accounts Production", "Item Description is already present.", 'warning');
          return false;
        }
      }
    }
    for (var i = 0; i < this.CreateTradecreditorsSoletraderFormGroup.value.Wizardrows.length; i++) {
      if ((this.CreateTradecreditorsSoletraderFormGroup.value.Wizardrows.length > 0) && (this.CreateTradecreditorsSoletraderFormGroup.value.Wizardrows[i].ItemDescription == null || this.CreateTradecreditorsSoletraderFormGroup.value.Wizardrows[i].ItemDescription == "")) {
        //Swal.fire("Andica Accounts Production", 'Item description must be completed.', 'warning');
        this.valid = false;
        return false;
      }
      else {
        this.valid = true;
      }
    }
    return true;

  }

  CalculationsGrid() {
    debugger;
    this.Amount = 0;
    this.Amount_LY = 0;
    for (var i = 0; i < this.ListCreateTradecreditorsSoletraderFormGroupGrid.length; i++) {
      this.Amount = this.Amount + +this.ListCreateTradecreditorsSoletraderFormGroupGrid.value[i].Amount;
      this.Amount_LY = this.Amount_LY + +this.ListCreateTradecreditorsSoletraderFormGroupGrid.value[i].Amount_LY;
    }
    this.CreateTradecreditorsSoletraderFormGroup.controls['Total'].setValue(this.Amount)
    this.CreateTradecreditorsSoletraderFormGroup.controls['Total_LY'].setValue(this.Amount_LY)

  }

  On_NextBalancesheatValidaton() {
    debugger;

    if (this.commonService.showControl == true) {
      if (+this.CreateTradecreditorsSoletraderFormGroup.controls['Total'].value != this.CreateTradecreditorsSoletraderFormGroup.controls['MatchingData'].value.Item1) {
        Swal.fire("Andica Accounts Production", "Total " + this.commonService.StartYear + " must tally with the Trade creditors field value in the Statement of Financial Position for the year " + this.commonService.StartYear + ".", 'warning');
        return false;
      }
      else if (+this.CreateTradecreditorsSoletraderFormGroup.controls['Total_LY'].value != this.CreateTradecreditorsSoletraderFormGroup.controls['MatchingData'].value.Item2) {
        Swal.fire("Andica Accounts Production", "Total " + this.commonService.LastYear + " must tally with the Trade creditors field value in the Statement of Financial Position for the year " + this.commonService.LastYear + ".", 'warning');
        return false;
      }
      else
        return true
    }
    else {
      if (+this.CreateTradecreditorsSoletraderFormGroup.controls['Total'].value != this.CreateTradecreditorsSoletraderFormGroup.controls['MatchingData'].value.Item1) {
        Swal.fire("Andica Accounts Production", "Total " + this.commonService.StartYear + " must tally with the Trade creditors field value in the Statement of Financial Position for the year " + this.commonService.StartYear + ".", 'warning');
        return false;
      }
      else
        return true
    }

  }



  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.CreateTradecreditorsSoletraderFormGroup.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:900'>You have unsaved data. </span><br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          debugger;
          this.NormalRoutng = true;
          if (this.On_Next()) {
            return true;
          }
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.Router.navigate(['/business']);

  }

  get ListCreateTradecreditorsSoletraderFormGroupGrid() {
    return this.CreateTradecreditorsSoletraderFormGroup.get('Wizardrows') as FormArray;
  }
}
